import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { IonRouterOutlet, ModalController, Platform } from '@ionic/angular';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MatchService } from '../../_core/services/match.service';
import { Extension } from '../../_shared/models/csTypes/extension';
import { Match } from '../../_shared/models/match.model';
import { BallChangePolicyComponent } from '../ball-change-policy/ball-change-policy.component';
import { BallChangeService } from './ball-change.service';
@Component({
  standalone: false,
    selector: 'app-ball-change',
    templateUrl: './ball-change.component.html',
    styleUrls: ['./ball-change.component.scss'],
})
export class BallChangeComponent implements OnInit, OnDestroy {
    @Input() match: Match;

    ballChange: { count: number, type: string };
    color = 'dark';
    private readonly destroy$: Subject<void> = new Subject();
    isTablet = false;

    constructor(
        private ballChangeService: BallChangeService,
        private matchService: MatchService,
        private modalController: ModalController,
        private routerOutlet: IonRouterOutlet,
        private platform: Platform
    ) { }


    ngOnInit() {
        this.isTablet = this.platform.is('tablet');
        this.getNumberOfUnits();

        this.matchService
            .subscribeScoreUpdated()
            .pipe(takeUntil(this.destroy$))
            .subscribe(
                (match: Match) => {
                    if (this.match._id === match._id) {
                        this.getNumberOfUnits();
                    }
                }
            );
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    async getNumberOfUnits() {
        this.ballChange = await this.ballChangeService.getBallChangeStatus(this.match);

        if (this.ballChange) {
            if (this.ballChange.count === 0) {
                this.color = 'danger';
            } else if (this.ballChange.count < (this.ballChange.type === 'GAME' ? 3 : 2)) {
                this.color = 'warning';
            } else {
                this.color = 'dark';
            }
        }

    }

    async changeBallChangePolicy() {
        const modal = await this.modalController.create({
            component: BallChangePolicyComponent,
            presentingElement: this.routerOutlet.nativeEl
        });

        await modal.present();

        const { data } = await modal.onDidDismiss();

        if (data) {
            const ballChangePolicyExtension: Extension = {
                name: 'ballChangePolicy',
                value: data.frequency ? data : null
            };

            const index = this.match.extensions.findIndex(ext => ext.name === 'ballChangePolicy');

            index === -1
                ? this.match.extensions.push(ballChangePolicyExtension)
                : this.match.extensions[index] = ballChangePolicyExtension;

            this.getNumberOfUnits();

            this.matchService
                .addExtension(this.match._id, ballChangePolicyExtension)
                .pipe(takeUntil(this.destroy$))
                .subscribe();
        }

    }


}
